import { useRef, useEffect } from 'preact/hooks';
import Button from '@/components/Common/Button';

interface VideoPreviewProps {
  videoUrl: string | null;
  onShare?: () => void;
  onClose: () => void;
}

const VideoPreview = ({ videoUrl, onShare, onClose }: VideoPreviewProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current && videoUrl) {
      videoRef.current.src = videoUrl;
      videoRef.current.load();
      videoRef.current.play().catch(err => console.error('Error playing video:', err));
    }
  }, [videoUrl]);

  if (!videoUrl) return null;

  return (
    <div className="fixed inset-0 z-50 bg-[rgba(19,26,53,0.5)] flex flex-col items-center justify-center p-4 short:p-3">
      <div className="flex flex-col items-center">
        <div className="relative w-full max-w-xs short:max-w-[260px] mx-auto rounded-[20px] short:rounded-[16px] overflow-hidden shadow-[0px_0px_20px_0px_rgba(0,0,0,0.25)]">
          <div className="relative w-full aspect-[9/16] bg-black">
            <video 
              ref={videoRef}
              className="w-full h-full object-cover" 
              loop
              playsInline
              style={{ objectPosition: 'center' }}
              muted
            />
            <div className="absolute inset-0 border-2 border-white rounded-[20px] short:rounded-[16px] pointer-events-none"></div>
          </div>
          
          <button 
            onClick={onClose}
            className="absolute top-4 right-4 w-10 h-10 rounded-full bg-[rgba(0,0,0,0.2)] border-2 border-white flex items-center justify-center"
            aria-label="Close video preview"
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="short:w-3 short:h-3">
              <path d="M13 1L1 13M1 1L13 13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        
        {onShare && (
          <div className="mt-8 short:mt-5 w-full flex justify-center ">
            <Button className="!bg-black !bg-opacity-50 !border-white !text-white"
              onClick={onShare}
            >
              SHARE
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoPreview;